"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight, Phone } from "lucide-react";
const steps = [{
  title: "Personalized Connection",
  description: "Discuss your needs for our small Silver Spring home where our 5-resident limit ensures truly personalized care."
}, {
  title: "Experience Our Small Home",
  description: "Tour our residence to see how our 5-resident capacity allows for a deeply personalized, family-like experience."
}, {
  title: "Join Our 5-Resident Family",
  description: "Welcome your loved one to a small home environment focused entirely on providing personalized care for just 5 seniors."
}];
export default function SimpleSteps() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: stepsRef,
    isVisible: stepsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="simple-steps" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-20 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl font-serif font-medium mb-6 tracking-tight">
            A Small, Family-Like Assisted Living Home in Silver Spring for 5 Residents
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Experience the Family First Senior Care difference in our intimate residential setting in Maryland. We provide 
            highly personalized care where our 5-resident limit ensures your loved one always receives the attention they deserve.
          </p>
        </div>

        {}
        <div ref={stepsRef} className={`relative transition-all duration-1000 delay-200 ease-out ${stepsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="hidden md:block absolute top-12 left-[16.66%] right-[16.66%] h-px bg-border/60" aria-hidden="true" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
            {steps.map((step, i) => <div key={i} data-index={i} className="relative flex flex-col items-center text-center group">
                {}
                <div className="w-24 h-24 rounded-full bg-primary/15 border border-primary/20 flex items-center justify-center mb-8 relative z-10 shadow-sm transition-transform duration-500 group-hover:scale-105 group-hover:bg-primary/25">
                  <span className="text-4xl font-serif text-primary font-medium">
                    {i + 1}
                  </span>
                </div>

                {}
                <h3 className="text-2xl font-serif font-medium mb-4 text-foreground">
                  {step.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed max-w-[280px]">
                  {step.description}
                </p>
              </div>)}
          </div>
        </div>

        {}
        <div className={`mt-20 text-center flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-1000 delay-500 ease-out ${stepsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Button asChild size="lg" className="rounded-full px-8 h-14 text-base">
            <Link to="/ContactPage">
              Schedule a Tour <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="rounded-full px-8 h-14 text-base border-primary/20 hover:bg-primary/10">
            <Link to="tel:3015551234"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-phone mr-2 size-5 text-primary" aria-hidden="true" data-ast-id="f:/src/pages/ScheduleATour/sections/SimpleSteps.tsx|sig:gommsd" data-ast-start="3927" data-ast-end="4540"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" data-ast-id="f:/src/pages/ScheduleATour/sections/SimpleSteps.tsx|sig:9sz9dp" data-ast-start="4303" data-ast-end="4534"></path></svg>(301) 477-9770&nbsp;</Link>
          </Button>
        </div>
      </div>
    </section>;
}